// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"banner-auth-warning_wrapper__NF3ze","txt":"banner-auth-warning_txt__szof0","btn":"banner-auth-warning_btn__3Z4Af"};